<!-- @veltra/icons generated sha256:a7b62697ba964d90 gen:8 source:src/svg/colorful/unknown-file.svg -->
<script setup lang="ts">
defineOptions({ name: 'UnknownFile' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
    <defs>
      <clipPath id="a"><rect width="16" height="16" rx="0" /></clipPath>
    </defs>
    <g clip-path="url(#a)">
      <path
        fill="#c7dadd"
        d="M10.308 1.003H4.225c-1.22 0-2.208.989-2.208 2.208v9.578c0 1.22.988 2.208 2.208 2.208h7.586c1.22 0 2.208-.989 2.208-2.208V4.714c0-.497-.198-.974-.55-1.326l-1.835-1.836a1.88 1.88 0 0 0-1.326-.549"
      />
      <path
        fill="#9dc0c9"
        d="m13.47 3.388-1.836-1.836a1.9 1.9 0 0 0-.965-.514v2.06c0 .655.53 1.185 1.185 1.185h2.115a1.9 1.9 0 0 0-.499-.895M8.008 4.624A2.33 2.33 0 0 0 5.682 6.95a.354.354 0 1 0 .709 0 1.62 1.62 0 0 1 2.761-1.143c.306.306.474.712.474 1.143a1.62 1.62 0 0 1-1.018 1.503 1.5 1.5 0 0 0-.954 1.396v.026a.354.354 0 1 0 .709 0v-.026c0-.325.2-.614.509-.738a2.32 2.32 0 0 0 1.463-2.16c0-.622-.242-1.206-.682-1.646a2.3 2.3 0 0 0-1.645-.681m-.18 7.099a.472.472 0 1 0 .362-.873.472.472 0 0 0-.362.873"
      />
      <path
        fill="#fff"
        d="M9.662 5.114a2.3 2.3 0 0 0-1.644-.682A2.33 2.33 0 0 0 5.69 6.76a.354.354 0 1 0 .709 0A1.62 1.62 0 0 1 9.16 5.615c.306.306.475.712.475 1.144a1.62 1.62 0 0 1-1.018 1.503 1.5 1.5 0 0 0-.955 1.396v.026a.354.354 0 1 0 .71 0v-.026c0-.325.199-.615.508-.738a2.32 2.32 0 0 0 1.463-2.161c0-.621-.242-1.205-.682-1.645m-2.116 5.981a.473.473 0 1 0 .945.001.473.473 0 0 0-.945 0"
      />
    </g>
  </svg>
</template>
